module.exports = __webpack_public_path__ + "img/u4330.e365341a.svg";